import React, { useContext } from 'react';
import cn from 'classnames';

// Hooks
import { useTranslation } from 'Shared/contexts/TranslationsContext';
import { useToggle } from 'Shared/utils/hooks';

// Context
import ExpandNavbarContext from 'Shared/contexts/ExpandNavbarContext';

// Components
import WpIcon from 'Wpds/components/icon/WpIcon';
import { WpDrawerV2, WpDrawerV2Body } from 'Wpds/components/drawer';
import DayCalendarMeetings from 'Shared/components/DayCalendarMeetings/DayCalendarMeetings';
import { WpTooltip, WpTooltipContent, WpTooltipTrigger } from 'Wpds/components/tooltip';

type Props = {
  handleCloseNavbar: Function;
};

const TodayScheduleNavLink = ({ handleCloseNavbar }: Props) => {
  const isExpanded = useContext(ExpandNavbarContext);

  const [isOpen, toggleIsOpen] = useToggle(false);
  const { tr } = useTranslation();

  const handleOpenCalendar = () => {
    if (isExpanded) handleCloseNavbar();
    toggleIsOpen();
  };

  return (
    <>
      <WpTooltip placement="right">
        <WpTooltipTrigger>
          <li className="Notifications nav-item" onClick={handleOpenCalendar}>
            <div className={cn('nav-link d-flex align-items-center cursor-pointer', { active: isOpen })}>
              <div
                className={cn('side-navigation-icon position-relative', {
                  'mx-auto': !isExpanded,
                })}
              >
                <WpIcon name="calendar-day" />
              </div>
              {isExpanded && <div className="d-inline">{tr('perform.navigation.today_schedule.title')}</div>}
            </div>
          </li>
        </WpTooltipTrigger>
        {!isExpanded && <WpTooltipContent>{tr('perform.navigation.today_schedule.title')}</WpTooltipContent>}
      </WpTooltip>
      <WpDrawerV2 isOpen={isOpen} toggleIsOpen={toggleIsOpen} title="">
        <WpDrawerV2Body>
          <DayCalendarMeetings />
        </WpDrawerV2Body>
      </WpDrawerV2>
    </>
  );
};

export default TodayScheduleNavLink;
